export const PORTLET_ID = '0'